export default __webpack_public_path__ + "static/media/icon_educationFees.46987d84.svg";